import React,{useEffect, useState} from 'react';
import "./PostCheckInTaxi.css";
import Header from '../../components/Header';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from '../../../customHooks/useAuth';
import { toast } from 'react-toastify';
import { baseUrl } from '../../../common/baseUrl';
import PageLoader from '../../components/PageLoader/PageLoader';
import axiosInstance from '../../../axiosInstance/axiosInstance';
import { getCurrentUser } from '../../../common/currentUser';
import PromoSection from '../FoodSummary/PromoSection';
import { HOTEL_TIMEZONE, toHotelISO } from "../../../common/hotelTime";

export default function PostCheckInTaxi() {

    
    const location = useLocation();
    const navigate = useNavigate();
    
    const bookedRooms = location.state?.bookedRooms || [];
    const userId = localStorage.getItem("user_id");
    
    const bookingId = location.state?.bookingId || "";
    const hotelId = location.state?.hotelId || "";
    const hotelAddress = location.state?.hotelAddress || "";
    const hotelName = location.state?.hotelName || '';
    const checkInDate = location.state?.checkInDate || "";
    const checkOutDate = location.state?.checkOutDate || "";
    const status = location.state?.status || "";
    const activeTab = location.state?.activeTab || "";
    const booking_code = location.state?.booking_code || "";


    // Fpr Update 
    const bookedRoomId = location.state?.bookedRoomId || "";
    const update = location.state?.update || "";
  
    const people = location.state?.people || "";
    const time = location.state?.time || "";
    const pickUplocation = location.state?.location || "";
    const dropOfLocation = location.state?.dropLocation || "";
    const cabRequestData = location.state?.cabRequestData || {};


    // console.log("Cab Request Data  : ",cabRequestData)


    // Get today's and tomorrow's date
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);


    // Refresh Handle
    useAuth();

    useEffect(()=>{
        const checkId = ()=>{
            if(bookingId==="" || hotelId==="" || hotelAddress===""){
                navigate("/bookings");
            }
        }
        checkId();
    },[bookingId,hotelId,hotelAddress,navigate]);

    
    // Error Handling
    const [errors, setErrors] = useState({});

    // Loading
    const [isLoading,setIsLoading] = useState(false);

    // Applied promo (offer object | null). The hotel quotes the fare later,
    // so we only attach the code here — no live discount preview.
    const [appliedPromo,setAppliedPromo] = useState(null);
    const handleApplyPromo = (offer) => setAppliedPromo(offer);
    const handleRemovePromo = () => setAppliedPromo(null);

    // Use one useState hook to store all form data
    // In this the field enter in formData I need for Update if there is change
    const [formData, setFormData] = useState({
        serviceDate: "",
        location : "" || (hotelName+", "+hotelAddress),    
        time : "",
        people : "" || people,
        dropLocation : "" || dropOfLocation
    });

    // Format Date
    const formatDate = (date) => {
        return date.toLocaleDateString('en-GB', {
            timeZone: HOTEL_TIMEZONE,
        day: 'numeric',
        month: 'short',
        });
    };

    // Function to handle date selection
    const handleDateSelection = (selectedDate) => {
        setFormData((prevState) => ({
        ...prevState,
        serviceDate: selectedDate,
        }));
    };

    // OnChange
    const handleChange = (e) => {
        const { name, value } = e.target;
    
        // People field specific validation
        // if (name === 'people' && (/\s/.test(value) || isNaN(value) || parseInt(value) <= 0)) {
        //   setErrors((prevErrors) => ({
        //     ...prevErrors,
        //     people: 'People must be a positive number with no spaces.',
        //   }));
        // } else {
        //   setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        // }
    
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
        validateField(name,value)

    };

    //  Setting up For Editing
    useEffect(() => {
        if (time) {

            const formatEditTime = (dateString) => {
                const date = new Date(dateString);
              
                // Format to 'HH:mm' (e.g., 10:10)
                return date.toLocaleTimeString([], {
            timeZone: HOTEL_TIMEZONE,
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false  // Ensures 24-hour format
                });
            };

            // console.log("TIme : ",time)
            // Extract the time in HH:mm format
            // const timeString = isoDate.toISOString().substring(11, 16);  
            const timeData = formatEditTime(time);
            // console.log("TIme Daata : ",timeData)

            
            const isoDate = new Date(time);

            // console.log("Data : ",isoDate)
            // Date Part
            const datePart = formatDate(isoDate);
            if(datePart===formatDate(today) || datePart === formatDate(tomorrow)){
                setFormData(prevState => ({
                    ...prevState,
                    serviceDate: datePart,  // Set formatted date for the service date
                    time: timeData        // Set the extracted time
                }));
            }
            else{
                
                // If the serviceDate is not today or tomorrow, reset it to empty
                formData.serviceDate = "";
                formData.time = ""; // You can also reset the time if the date is invalid
            }
                        
        }
    }, [time]);



    // Validate Field
    const validateField = (field, value)=>{
        const newErrors = { ...errors };
        switch(field){
            
            case "location":
                if (!value.trim()) {
                    newErrors.location = "Pick-up location is required";
                  } else {
                    newErrors.location = "";
                  }
            break;
            
            case "people":
                if ((/\s/.test(value) || isNaN(value) || parseInt(value) <= 0)) {
                    newErrors.people = "Please enter a valid number of people (must be greater than 0)";
                }
                else{
                    newErrors.people = "";
                }
            break;

            case "serviceDate":
                if (!value.trim()) {
                    newErrors.serviceDate = "Please select a service date";
                } else {
                    newErrors.serviceDate = "";
                }
            break;

            case "time":
                if (!value.trim()) {
                    newErrors.time = "Please select a time for the cab";
                } else {
                    newErrors.time = "";
                }
            break;

            case "dropLocation":
                if (!value.trim()) {
                    newErrors.dropLocation = "Drop off Location Required";
                }
                else{
                    newErrors.dropLocation = "";
                }
                break;

            default:
                break;

        }
        setErrors(newErrors);
    }



    // Validation Form
    const validateForm = () => {
        const validationErrors = {};
    
        if (!formData.location.trim()) {
          validationErrors.location = "Pick-up location is required";
        }
    
        if (!formData.people || isNaN(formData.people) || parseInt(formData.people) <= 0) {
          validationErrors.people = "Please enter a valid number of people (must be greater than 0)";
        }
    
        if (!formData.serviceDate) {
          validationErrors.serviceDate = "Please select a service date";
        }
    
        if (!formData.time) {
          validationErrors.time = "Please select a time for the cab";
        }

        if(!formData.dropLocation.trim()){
            validationErrors.dropLocation = "Drop off Location Required";

        }
    
        setErrors(validationErrors);
    
        return Object.keys(validationErrors).length === 0;
    };

 
    // Submit Handler
    const handleSubmit = async()=>{

        
        try{

        if (!validateForm()) {
        //    console.log("FOrm Has Some errors Fix it")
            return;
        }

        setIsLoading(true);

       
        // Get current year
        const currentYear = new Date().getFullYear();
        const selectedDate = new Date(`${formData.serviceDate} ${currentYear}`); 
        const [hours, minutes] = formData.time.split(':');

        // Set the time to the selected date
        selectedDate.setHours(hours);
        selectedDate.setMinutes(minutes);
        selectedDate.setSeconds(0);

        // Format function without converting to UTC
        // Get the formatted date-time with specified offset
        const isoDateTimeWithInd = toHotelISO(selectedDate);
        // console.log("Date with Offset: ", isoDateTimeWithInd);


        // console.log("Data : ",formData);
        // Clean and convert 'people' from string to integer
        const cleanedPeople = formData.people;
        const people = parseInt(cleanedPeople, 10); // Parse as integer, base 10

        const passData  = {
            number_of_people : people,
            pick_up_location : formData.location,
            drop_off_location : formData.dropLocation,
            time_of_arrival : isoDateTimeWithInd,
            promo_code : appliedPromo?.code || ""
        };
        // console.log("Pass Data : ",passData);
 

        // THis is for Update The Data
        if(update){
            try{

                const response = await axiosInstance.put(`/api/v1/users/${cabRequestData.user_id}/bookings/${bookingId}/booked-rooms/${bookedRoomId}/guest-requests/post-checkin/cab-request/${cabRequestData.id}`,passData);

                // console.log("Data For CAb Request Updated Successfully : ",response);
                toast.success("PostCheckIn Cab Request Updated Successfully");
                navigate("/bookings",{state : {activeRequests : "requests"}});
            }
            catch(error){
                toast.error(error?.response?.data?.message || "Some Error Occured");
                console.log(error);
            }
        }
        else{

            // For Getting The Id Which Has User inside that Room
            const currentUser = await getCurrentUser();
 
            function findMatchedRooms(bookedRooms, usersData) {
                const contact = usersData.contact;
                const matchedRooms = bookedRooms.filter((room)=>{
                    // Check if guests are null or an empty array, and skip the room if true
                    if (!room.guests || room.guests.length === 0) {
                        return false; // Skip this room
                    }
                    const matchedGuest = room.guests.find((guest)=>guest.contact===contact);
                    if(matchedGuest) {
                        return true; //
                    }
                    else{
                        return false;
                    }
                });
                return matchedRooms;
            }        
      
            const usersData = currentUser;  
            const matchedRooms = findMatchedRooms(bookedRooms, usersData);
      
            if(matchedRooms.length<=0){
            //   console.log("Booking is not Present ");
              return;
            }
            // console.log("MAtched Rooms : " + matchedRooms[0].id);



            try{
                const response = await axiosInstance.post(`/api/v1/users/${userId}/bookings/${bookingId}/booked-rooms/${matchedRooms[0].id}/guest-requests/post-checkin/cab-request/`,passData);
                // console.log("Success from New Booking Cab : ",response.data);
                toast.success("PostCheckIn Cab Request Created Successfully");
                navigate("/bookings",{state : {activeRequests : "requests"}});
            }catch(error){
                toast.error(error.response.data.message);
                console.log(error);
            }
        }

        }catch(error){
            console.log(error)
        }
        finally{
            setIsLoading(false);
        }
    
    }
        

  return (
    <>
        {
            isLoading && <PageLoader/>
        }

        <div className='postCheckInCab'>

            {update ? 

            <Header
                title="Book Your Cab" 
            /> 
            
            : 
            
            <Header  title="Book Your Cab" 
                hotelName = {hotelName}
                hotelAddress = {hotelAddress}
                checkInDate = {checkInDate}
                checkOutDate = {checkOutDate}
                status = {status}
                activeTab = {activeTab}
                hotelId = {hotelId}
                bookingId = {bookingId}
                movetoHotel = "movetoHotel"
                booking_code = {booking_code}
            />
            }
    
            <div className="pickupData">
                {/* Pick Up Location */}
                <div className="pickupData-addr">
                    <h4>Pick Up Location</h4>
                    <textarea rows='4' cols="10" name="location" onChange={handleChange} value={formData.location}></textarea>
                    {errors.location && <span className="error-message">{errors.location}</span>}
                </div>

                {/* Drop Location */}
                <div className="pickupData-adder">
                    <h4>Drop off Location</h4>
                    <textarea rows='4' cols="10" name="dropLocation" onChange={handleChange} value={formData.dropLocation}
                    ></textarea>
                    {errors.dropLocation && <span className="error-message">{errors.dropLocation}</span>}
                </div>


                {/* Number of People */}
                <div className='pickupData-people'>
                    <h4>Number of People</h4>
                    <input type='text' maxLength={2} name="people"  onChange={handleChange} value={formData.people}  />
                    {errors.people && <span className="error-message">{errors.people}</span>}
                </div>

                {/* Date of Trip */}
                <div className='pickupData-date'>
                    <h4>Date of the trip</h4>
                    <div className='date-selection'>
                        <div
                        className={`date-box ${formData.serviceDate === formatDate(today) ? 'selected' : ''}`}
                        onClick={() => handleDateSelection(formatDate(today))}
                        >
                        {formatDate(today)}  
                        </div>
                        <div
                        className={`date-box ${formData.serviceDate === formatDate(tomorrow) ? 'selected' : ''}`}
                        onClick={() => handleDateSelection(formatDate(tomorrow))}
                        >
                        {formatDate(tomorrow)}  
                        </div>
                    </div>
                    {errors.serviceDate && <span className="error-message">{errors.serviceDate}</span>}
                </div>

                {/* Promo Code — only on create (edit hits a different update endpoint) */}
                {!update && (
                    <PromoSection
                        userId={userId}
                        hotelId={hotelId}
                        service="PostCheckin Cab Request"
                        appliedPromo={appliedPromo}
                        onApply={handleApplyPromo}
                        onRemove={handleRemovePromo}
                        previewDiscount={false}
                    />
                )}

                {/* Request Cab Btn Time */}
                <div className='pickup-btn-time'>
                    <h4>When do you want the cab</h4>
                    <div className='cab-btn-time'>
                        <div className='cabTime'>
                            <input type='time' name="time" onChange={handleChange} value={formData.time} />
                        </div>
                        <div className='cabBtn'>
                            <button disabled={formData.serviceDate==="" || formData.location==="" || formData.time==="" || formData.people==="" || formData.dropLocation===""} onClick={handleSubmit}>Request Cab</button>
                        </div>
                    </div>
                    {errors.time && <span className="error-message">{errors.time}</span>}
                </div>

            </div>

        </div>
    </>
  )
}
